import Grow from '@material-ui/core/Grow';
import IconButton from '@material-ui/core/IconButton';
import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import ArrowLeftThin from '@ori-ui/icons/lib/ArrowLeftThin';
import Cross from '@ori-ui/icons/lib/Cross';
import clsx from 'clsx';
import React, { forwardRef, useCallback, useMemo } from 'react';
import useAutoclose from '../useAutoclose';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const componentConfig = {
  name: 'MuiOriDialogBase'
};

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    outline: 0
  },
  backButton: {
    position: 'absolute',
    top: 0,
    left: 0,
    padding: theme.spacing(1),
    margin: theme.spacing(1)
  },
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    padding: theme.spacing(1),
    margin: theme.spacing(1)
  },
  dialogGrid: {
    display: 'grid',
    justifyItems: 'center',
    position: 'relative',
    minWidth: 320,
    maxWidth: '60vw',
    minHeight: 100,
    outline: 0,
    padding: theme.spacing(6)
  }
});

export const DialogBase = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    open,
    hideCloseButton,
    showBackButton,
    backButton,
    onBack,
    className,
    disableTransition,
    classes,
    timeoutMs = 2000,
    autoClose,
    ...modalProps
  } = props;
  const {
    onClose
  } = modalProps;
  const handleClose = useCallback(event => {
    onClose == null ? void 0 : onClose(event != null ? event : {}, 'escapeKeyDown');
  }, [onClose]);
  useAutoclose({
    autoClose,
    open,
    timeoutMs,
    onClose: handleClose
  });
  const handleBackClick = useCallback(() => {
    onBack == null ? void 0 : onBack();
  }, [onBack]);
  const internalBackButton = useMemo(() => {
    if (!showBackButton) return null;
    if (backButton) return backButton;
    return /*#__PURE__*/_jsx(IconButton, {
      "data-testid": "back-button",
      classes: {
        root: classes.backButton
      },
      onClick: handleBackClick,
      children: /*#__PURE__*/_jsx(ArrowLeftThin, {
        color: "inherit"
      })
    });
  }, [backButton, showBackButton, handleBackClick, classes]);
  const internalCloseButton = useMemo(() => {
    if (hideCloseButton) return null;
    return /*#__PURE__*/_jsx(IconButton, {
      "data-testid": "close-button",
      classes: {
        root: classes.closeButton
      },
      onClick: handleClose,
      children: /*#__PURE__*/_jsx(Cross, {
        fontSize: "small",
        color: "inherit"
      })
    });
  }, [hideCloseButton, handleClose, classes]);
  return /*#__PURE__*/_jsx(Modal // @ts-expect-error wrong ref type
  , {
    ref: ref,
    closeAfterTransition: true,
    className: clsx(classes.root, className),
    open: open,
    ...modalProps,
    children: /*#__PURE__*/_jsx(Grow, {
      in: open,
      children: /*#__PURE__*/_jsxs(Paper, {
        classes: {
          root: classes.dialogGrid
        },
        children: [internalBackButton, internalCloseButton, children]
      })
    })
  });
});
export default withStyles(styles, componentConfig)(DialogBase);